let apiVersion = process.env.REACT_APP_API_URL;

//Authorization URL
export const getUserLoggedInUrl = `${apiVersion}/users/login`;
export const getCustomerSignUpUrl = `${apiVersion}/users/customerSignUp`;
export const getUserLogOutUrl = `${apiVersion}/users/userLogout`;
export const getForgotPasswordUrl = `${apiVersion}/users/forgotPasswordRequest`;
export const getResetPasswordUrl = `${apiVersion}/users/passwordResetRequest`;
export const getChangePasswordUrl = `${apiVersion}/users/changePassword`;
export const getAccessTokenUrl = `${apiVersion}/users/refreshToken`;

export const getAddTeacherUrl = `${apiVersion}/users/addSchoolTeacher`;

export const getAcademicCourseListUrl = `${apiVersion}/courses/academicCourseList`;
export const getAcademicCourseUrl = `${apiVersion}/courses/getAcademicCourse`;
export const getAcademicLessonUrl = `${apiVersion}/courses/getCourseLesson`;
export const saveCourseLessonProgressUrl = `${apiVersion}/courses/saveCourseLessonProgress`;
export const getStudentProfileUrl = `${apiVersion}/users/getStudentProfile`;
export const getEditProfileUrl = `${apiVersion}/users/editStudentProfile`;
export const CreateStudentProfileUrl = `${apiVersion}/users/createStudentProfile`;
export const getDownloadCertificateUrl = `${apiVersion}/courses/downloadCourseCertificate`;

export const getSchoolAdminProfileUrl = `${apiVersion}/users/getSchoolAdminProfile`;
export const updateSchoolAdminProfileUrl = `${apiVersion}/users/UpdateSchoolAdminProfile`;

export const getCountryListUrl = `${apiVersion}/common/getCountry`;
export const getStateListUrl = `${apiVersion}/common/getState`;
export const getCityListUrl = `${apiVersion}/common/getCity`;

export const getUploadSignedUrl = `${apiVersion}/common/getUploadSignedURL`;

export const getAttendanceListUrl = `${apiVersion}/attendance/attendanceListStudent`;
export const getAdminAttendanceListUrl = `${apiVersion}/attendance/attendanceList`;
export const getAdminAttendanceSummaryUrl = `${apiVersion}/attendance/attendanceSummaryList`;

export const getNefPaymentListUrl = `${apiVersion}/users/nefPaymentList`;
export const getNefSubmissionVerifyUrl = `${apiVersion}/users/nefSubmissionVerify`;
export const getNefSubmissionUrl = `${apiVersion}/users/nefSubmissions`;

export const saveIITBombayFestUrl = `${apiVersion}/company_events/addIITBombayDetails`;
export const downloadIITBombayFestUrl = `${apiVersion}/company_events/downloadIITBombayCertificate`;
export const iitBombayFestListingUrl = `${apiVersion}/company_events/iitBombayList`;

export const getStudentListUrl = `${apiVersion}/users/studentListForHead`;

export const getSchoolTeacherListUrl = `${apiVersion}/users/schoolTeachersList`;


export const getClassListUrl = `${apiVersion}/academics/classList`;
export const getSectionListUrl = `${apiVersion}/academics/sectionList`;

export const getSessionListUrl = `${apiVersion}/academics/sessionList`;

export const getCompletedTopicListUrl = `${apiVersion}/mentor_academics/completedTopicsList`;
export const getSchoolAdminDashboardUrl = `${apiVersion}/mentor_academics/schoolAdminDashboardList`;

export const getBooksListUrl = `${apiVersion}/books/books`;
export const getBooksDetailsUrl = `${apiVersion}/books/books/details`;
export const getBooksAddToCartUrl = `${apiVersion}/books/cart/add`;
export const getBooksCartListUrl = `${apiVersion}/books/cart`;
export const getBooksRemoveCartUrl = `${apiVersion}/books/cart/remove`;
export const getBooksCheckoutUserListUrl = `${apiVersion}/books/orders/checkout/list`;
export const getBooksOrderCreateUrl = `${apiVersion}/books/orders/create`;
export const getBooksOrderVerifyUrl = `${apiVersion}/books/orders/verify`;
export const getBooksOrderFailureUrl = `${apiVersion}/books/orders/failure`;
export const getBooksOrderRetryUrl = `${apiVersion}/books/orders/retry`;
export const getBooksLibraryPurchasedUrl = `${apiVersion}/books/library`;
export const getBooksPurchasedProgressUrl = `${apiVersion}/books/library/progress`;
export const getBooksLessonSlidesUrl = `${apiVersion}/books/library`;
export const getBooksBookmarksUrl = `${apiVersion}/books/library`;
export const getBooksBookmarkDeleteUrl = `${apiVersion}/books/bookmarks`;
export const getBooksNotesUrl = `${apiVersion}/books/library`;
export const getBooksNoteUpdateUrl = `${apiVersion}/books/notes`;
export const getBooksPurchasedReviewUrl = `${apiVersion}/books/books/reviews`;
export const getBooksCreateReviewUrl = `${apiVersion}/books/reviews/create`;
export const getBooksUpdateReviewUrl = `${apiVersion}/books/reviews`;
